/* eslint-disable react/jsx-no-useless-fragment */
import { Container, Grid, Tab, Tabs } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ADD_INSIGHTS, SET_ORG_FEEDS } from '../../../redux/constants';
import { getClassOverview } from '../../../service/states.service';
import {
  AppWeeklySales,
  TotalClasses,
  TeacherBoard,
  AppNoOfTestsReports
} from '../../../components/_dashboard/app';
import Page from '../../../components/Page';
// import Classwise from './Teacher.Classwise';
import EmptyDashboard from '../../../components/EmptyDashboard';
import EmptyDashboardChart from '../../../components/EmptyDashboardChart';
import TeacherDashboardFeeds from './TeacherFeed';
import { getAllFeedsByOrg } from '../../../service/feed.service';
import { SkeletonDashboardFeed } from '../../../fl-components/skeleton/SkeletonDashboardFeed';

export default function TeacherInsights() {
  const orgStates = useSelector((state) => state.insights.data);
  const feedList = useSelector((state) => state.feeds.orgFeeds);
  const [isLoading, setIsLoading] = useState(feedList === null);
  const selectedOrg = useSelector((state) => state.org.selectedOrg);
  const feedOffset = useSelector((state) => state.feeds.orgFeedOffset);
  const dispatch = useDispatch();
  const [currentTab, setCurrentTab] = useState(0);

  useEffect(() => {
    async function fetchFeedList() {
      const res = await getAllFeedsByOrg(selectedOrg?.id ?? selectedOrg?.orgId, feedOffset);
      if (res) {
        dispatch({
          type: SET_ORG_FEEDS,
          payload: {
            feeds: res.results,
            offset: feedOffset + 1
          }
        });
        setIsLoading(false);
      } else {
        setIsLoading(false);
      }
    }

    async function fetchClassOverview() {
      if (selectedOrg?.orgId) {
        const res = await getClassOverview(selectedOrg?.id ?? selectedOrg?.orgId);
        if (res) {
          dispatch({ type: ADD_INSIGHTS, payload: res });
        }
      }
    }
    if (orgStates === null) fetchClassOverview();
    if (feedList === null) fetchFeedList();
  }, [selectedOrg]);

  // const teacherClassList = [
  //   { label: 'Basic Mathematics', value: 'basic mathematics' },
  //   { label: 'Art', value: 'art' },
  //   { label: 'Painting', value: 'painting' }
  // ];
  return (
    <Page title="Dashboard">
      {isLoading ? (
        <SkeletonDashboardFeed />
      ) : (
        <Container>
          <Tabs
            value={currentTab}
            onChange={(event, newValue) => setCurrentTab(newValue)}
            variant="scrollable"
            scrollButtons={false}
            aria-label="scrollable prevent tabs example"
            sx={{ mb: 2 }}
          >
            <Tab label="Feeds" />
            <Tab label="Insights" />
          </Tabs>
          {currentTab === 0 && <TeacherDashboardFeeds />}
          {currentTab === 1 && (
            <>
              {Object.keys(orgStates).length > 0 ? (
                <Grid container spacing={3}>
                  <Grid item xs={12} sm={6} md={3}>
                    <AppWeeklySales value={orgStates?.totalStudents} />
                  </Grid>
                  <Grid item xs={12} sm={6} md={3}>
                    <TotalClasses value={orgStates?.totalClasses} />
                  </Grid>
                  <Grid item xs={12} sm={6} md={3}>
                    <TeacherBoard value={orgStates?.totalHours} />
                  </Grid>
                  <Grid item xs={12} sm={6} md={3}>
                    <AppNoOfTestsReports value={orgStates?.totalTests} />
                  </Grid>
                  {/* TODO: When we get the chart related data from api then we've to pass it in this component. */}
                  {/* <Classwise classesList={teacherClassList} /> */}
                  <EmptyDashboardChart />
                </Grid>
              ) : (
                <EmptyDashboard />
              )}
            </>
          )}
        </Container>
      )}
    </Page>
  );
}
